export const currency = (value, options = {}, locale = 'nl-NL') => {
    return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, ...options }).format(value);
};
